<template>
  <section class="references-section">
    <div class="container">
      <Carousel
        v-bind="settings"
        :breakpoints="breakpoints"
        :autoplay="2500"
        :wrap-around="true"
        pause-autoplay-on-hover
        class="references-carousel"
      >
        <Slide v-for="(slide, index) in references" :key="index">
          <div class="carousel__item">
            <img
              :src="slide.logo"
              :alt="slide.alt || 'Referans Logo'"
              class="ref-img"
              loading="lazy"
            />
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import "vue3-carousel/dist/carousel.css";

export default {
  name: "ReferencesSection",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    breakpoints: {
      640: {
        itemsToShow: 2.5,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 4,
        snapAlign: "start",
      },
      1024: {
        itemsToShow: 5.5,
        snapAlign: "start",
      },
    },
  }),
  setup() {
    const references = ref([]);

    onMounted(async () => {
      const q = query(
        collection(firestore, "referanslar"),
        where("durum", "==", true)
      );

      const querySnapshot = await getDocs(q);
      references.value = querySnapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id,
        alt: doc.data().alt || doc.data().isim || "Referans Logosu"
      }));
    });

    return {
      references,
    };
  },
};
</script>

<style scoped>
.references-section {
  padding: 0;
  background-color: #ffffff;
  text-align: center;
}

.section-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #145da0;
  font-weight: bold;
}

.carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  height: 100px;
}

.ref-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.ref-img:hover {
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .carousel__item {
    height: 80px;
  }
  .ref-img {
    max-height: 60px;
  }
}
</style>
